// src/combined-entry.js

// Import Three.js core
import * as THREE from "./three.js-r172/build/three.module.js";

// Import WebXR classes and attach them to THREE
import { XRControllerModelFactory } from "./three.js-r172/examples/jsm/webxr/XRControllerModelFactory.js";
import { XRHandModelFactory } from "./three.js-r172/examples/jsm/webxr/XRHandModelFactory.js";

window.THREEX = {
	XRControllerModelFactory,
	XRHandModelFactory
};

// Export everything under TH
export default THREE;